// extracted by mini-css-extract-plugin
export var childrenContainer = "_47-0";
export var virtualScrollArea = "_47-1";